import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export function TypeLine({
  text,
  speed = 24,
  onComplete,
}: {
  text: string;
  speed?: number;
  onComplete?: () => void;
}) {
  const [visible, setVisible] = useState('');

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      index += 1;
      setVisible(text.slice(0, index));

      if (index >= text.length) {
        clearInterval(interval);
        onComplete?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onComplete]);

  return <Typography variant="body2">{visible}</Typography>;
}
